interface StateConfig {
  label: string;
  className: string;
}

// Lead lifecycle is strictly new → qualified → booked (set by the public
// booking funnel; see hd-api/resolvers/public/booking.py).
const STATE_CONFIG: Record<string, StateConfig> = {
  new: { label: "New", className: "text-tide-d bg-tide-ss" },
  qualified: { label: "Qualified", className: "text-spark bg-spark-s" },
  booked: { label: "Booked", className: "text-sage bg-sage-s" },
};

interface LeadStateBadgeProps {
  status: string;
  className?: string;
}

export function LeadStateBadge({ status, className = "" }: LeadStateBadgeProps) {
  const config = STATE_CONFIG[status] ?? {
    label: status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    className: "text-ink-3 bg-canvas-2",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}
